import runtime from '../src/runtime/locales/zh-CN';
import renderer from '../src/renderer/locales/zh-CN';
import dataitem from '../src/components/locales/zh-CN';
export default {
    runtime,
    renderer,
    dataitem
};
